//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useEffect, useState } from 'react';
import styles from './style.module.scss';
import { useNav } from 'src/onboarding/hooks/nav';
import { Title } from 'src/onboarding/components/typography/Title/Title';
import { useRemoteConfig } from 'core/hooks/use-remote-config';
import { t } from '@web-solutions/module-localization';

import { useDispatch } from 'react-redux';
import { useAppSelector } from 'src/store/hooks';
import { submitCancelSubscription } from 'core/upsale/store/actions';
import { useUpsalePurchase } from 'core/upsale/hooks/use-upsale-purchase';
import { subscribe } from 'core/store/billing/actions';
import { PaymentSystem } from '@web-solutions/react-billing';
import { UPSALE_NAMES } from 'core/upsale/store/types';
import { ReactComponent as LoadingIcon } from '../../../../assets/images/loading-white.svg';
import Analytics from '@web-solutions/module-analytics';
import SuccessPayment from '../successPaymentPopup';
import FailedPayment from '../failedPaymentPopup';
import { Text } from 'src/onboarding/components/typography/Text/Text';
import Button from 'src/onboarding/components/ui/button/Button';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';

const UpsaleWithoutTrial = () => {
  const purchase = useAppSelector((state) => state.billing.purchase);

  const [loading, setLoading] = useState(false);
  const [successPayment, setSuccessPayment] = useState(false);
  const [failedPayment, setFailedPayment] = useState(false);
  const [showCheck, setShowCheck] = useState(false);

  const { onNext, onPrev } = useNav();
  const dispatch = useDispatch();

  const { upsaleWithoutTrial, skipPosition } = useRemoteConfig();

  const ONETIME_RECURLY_ID = upsaleWithoutTrial.oneTimeRecurlyId;

  const SUBSCRIBE_RECURLY_ID = upsaleWithoutTrial.product.recurlyId;

  const { handleUpsalePurchase, renderPaymentProcessor } = useUpsalePurchase();

  const handleSkipTrialClick = async () => {
    const formData = {
      price_id: SUBSCRIBE_RECURLY_ID,
      email: purchase?.email,
      first_name: purchase?.first_name,
      last_name: purchase?.last_name,
      method: purchase?.method,
      paymentSystem: PaymentSystem.RECURLY,
      token_id: purchase?.token_id,
    };

    setLoading(true);

    try {
      const data = await handleUpsalePurchase({
        recurlyId: ONETIME_RECURLY_ID,
        upsaleName: UPSALE_NAMES.SKIP_TRIAL,
      });

      if (!data) {
        setFailedPayment(true);
        return;
      }

      await dispatch(submitCancelSubscription(SUBSCRIBE_RECURLY_ID));

      await dispatch(subscribe(formData));

      setSuccessPayment(true);
      Analytics.trackEvent('step', 'completed', {
        upsaleID: 'upsale-without-trial',
        result: 'upsale_subscribe_success',
      });

      gtag('event', 'conversion', {
        'send_to': 'AW-17149973324/WBLJCNvSyP0aEMym3_E_',
        'value': upsaleWithoutTrial.totalPrice,
        'currency': 'USD',
        'transaction_id': ''
    });

    } catch (error) {
      setFailedPayment(true);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (successPayment) {
      Analytics.trackEvent('popup', 'shown', {
        type: 'payment-success',
        upsaleID: 'upsale-without-trial',
      });

      document.body.style.overflow = 'hidden';

      const showCheckTimer = setTimeout(() => setShowCheck(true), 500);
      const nextTimer = setTimeout(() => onNext(), 1500);

      return () => {
        clearTimeout(showCheckTimer);
        clearTimeout(nextTimer);
        document.body.style.overflow = '';
      };
    } else if (failedPayment) {
      Analytics.trackEvent('popup', 'shown', {
        type: 'failed-payment',
        upsaleID: 'upsale-without-trial',
      });
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [successPayment, failedPayment]);

  useEffect(() => {
    if (failedPayment) {
      const timer = setTimeout(() => setLoading(false), 1000);
      return () => clearTimeout(timer);
    }
  }, [failedPayment]);

  return (
    <>
      <main className={styles.main}>
        {renderPaymentProcessor({
          activeProduct: upsaleWithoutTrial.oneTimeId,
          subscribeRecurlyId: SUBSCRIBE_RECURLY_ID,
          isOnlyOneTimePurshaseUpsale: false,
          oneTimeRecurlyId: ONETIME_RECURLY_ID,
        })}
        <div
          onClick={() => {
            onNext();
            Analytics.trackEvent('step-completed', 'skip', {
              upsaleID: 'upsale-without-trial',
            });
          }}
          className={skipPosition === 'left' ? styles.skip : styles.skipRight}
        >
          {t('onboarding.upsaleWithoutTrial.skip')}
        </div>
        <Title tag='h2'>{t('onboarding.upsaleWithoutTrial.title')}</Title>
        <Text className={styles.subTitle} size='m' medium>
          {t('onboarding.upsaleWithoutTrial.subTitle')} 🎯
        </Text>

        <div className={styles.diagram}>
          <div className={styles.barGroup}>
            <div className={styles.trialBar}></div>
            <Text size='s' semibold className={styles.label}>
              {t('onboarding.upsaleWithoutTrial.trial')}
            </Text>
          </div>

          <div className={styles.barGroup}>
            <div className={styles.skipBar}>
              <Text semibold className={styles.barText}>
                {t('onboarding.upsaleWithoutTrial.percent')}
              </Text>
            </div>
            <Text size='s' semibold className={styles.label}>
              {t('onboarding.upsaleWithoutTrial.skipTrial')}
            </Text>
          </div>
        </div>

        {upsaleWithoutTrial.type === 'offer' && (
          <div className={styles.offer}>
            <Title tag='h4' className={styles.offerHeader}>
              {t('onboarding.upsaleWithoutTrial.offer')}
            </Title>
            <div className={styles.row}>
              <Text size='m' medium className={styles.price}>
                {upsaleWithoutTrial.planTitle}
              </Text>
              <Text size='m' medium className={styles.price}>
                {upsaleWithoutTrial.planPrice}
              </Text>
            </div>

            <div className={`${styles.row} ${styles.discountRow}`}>
              <Text size='m' medium className={styles.badge}>
                {upsaleWithoutTrial.discount}
              </Text>
              <Text size='m' medium className={styles.discountText}>
                {upsaleWithoutTrial.discountText}
              </Text>
              <Text size='m' medium className={styles.discountAmount}>
                {upsaleWithoutTrial.discountAmount}
              </Text>
            </div>

            <div className={`${styles.row} ${styles.totalRow}`}>
              <Text semibold className={styles.price}>
                {upsaleWithoutTrial.totalTitle}
              </Text>
              <Text semibold className={styles.totalPrice}>
                {upsaleWithoutTrial.totalPrice}{' '}
                <Text size='m' medium className={styles.oldPrice}>
                  {upsaleWithoutTrial.planPrice}
                </Text>
              </Text>
            </div>
          </div>
        )}

        {successPayment && (
          <SuccessPayment onClose={() => setSuccessPayment(false)} showCheck={showCheck} />
        )}

        {failedPayment && (
          <FailedPayment
            onClose={() => setFailedPayment(false)}
            onRetry={() => handleSkipTrialClick()}
            loading={loading}
          />
        )}
      </main>

      <footer className={styles.footer}>
        <Button
          disabled={loading}
          title={
            loading ? (
              <LoadingIcon />
            ) : upsaleWithoutTrial.type === 'offer' ? (
              upsaleWithoutTrial.buttonTitle
            ) : (
              t('onboarding.upsaleWithoutTrial.skipTrial')
            )
          }
          onClick={handleSkipTrialClick}
        />
        {upsaleWithoutTrial.description.length > 0 && (
          <Caption size='s' className={styles.description}>
            {upsaleWithoutTrial.description}
          </Caption>
        )}
      </footer>
    </>
  );
};

export default UpsaleWithoutTrial;
